import React from 'react';
import { 
  Home, 
  Calendar, 
  DollarSign, 
  Package, 
  Vote
} from 'lucide-react';

const haptics = {
  light: () => { 
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      navigator.vibrate(10); 
    }
  },
};

const BottomNav = ({ 
  currentPage, 
  onNavigate, 
  isAdmin = true,
  unvotedPollsCount = 0 
}) => {
  
  const handleNavigate = (page) => {
    haptics.light();
    onNavigate(page);
  };

  const navItems = [
    { id: 'dashboard', icon: Home, label: 'Home', show: true },
    { id: 'calendar', icon: Calendar, label: 'Calendar', show: true },
    { id: 'polls', icon: Vote, label: 'Polls', show: true, badge: unvotedPollsCount > 0 ? unvotedPollsCount : null },
    { id: 'summary', icon: DollarSign, label: 'Money', show: isAdmin },
    { id: 'inventory', icon: Package, label: 'Merch', show: true },
  ];

  const visibleItems = navItems.filter(item => item.show);

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 md:hidden">
      <div className="flex justify-around items-center py-2">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = currentPage === item.id;
          
          return (
            <button
              key={item.id}
              onClick={() => handleNavigate(item.id)}
              className={`relative flex flex-col items-center gap-1 px-3 py-2 transition-colors ${
                isActive 
                  ? 'text-blue-600 dark:text-blue-400' 
                  : 'text-gray-500 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400'
              }`}
            >
              <div className="relative">
                <Icon size={24} />
                {item.badge && (
                  <span className="absolute -top-2 -right-2 min-w-[20px] h-[20px] flex items-center justify-center bg-red-500 text-white text-[11px] font-bold rounded-full px-1 animate-pulse shadow-lg">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-xs ${isActive ? 'font-semibold' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
      <div className="pb-safe" />
    </div>
  );
};

export default BottomNav;